import { PlanMode, PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { BaseForStepsHelper, WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { RestoreStepsDataFromPlanHelper } from 'wizards/helpers/restore-steps-data-from-plan-helper/restore-steps-data-from-plan-helper';
import { StepsDataFromPlanHelper } from 'wizards/helpers/steps-data-from-plan-helper/steps-data-from-plan-helper';
import { SupportMethodsForStepsFromPlan } from 'wizards/helpers/support-methods-for-steps-from-plan';
import { RestoreDatabaseFormModel } from 'wizards/models/databaseRestore/restore-database-form-model';

export class RestoreDatabaseModelForStepsHelper extends BaseForStepsHelper {
  public static restoreDatabaseModel = new RestoreDatabaseFormModel(this.isNBF);

  public static restoreDatabaseModelFromPlan(plan, settings: WizardHelpersSettings = this.DefaultSettings): RestoreDatabaseFormModel {
    const newPlan = plan && (plan.plan || plan.Plan);

    if (newPlan) {
      this.setThisValues(plan, settings);
      this.setStorageType(settings.mode, newPlan.ConnectionID);

      const name =
        settings.mode === PlanMode.create || !newPlan.Name
          ? SupportMethodsForStepsFromPlan.generatePlanName(settings.compName, this.planType, this.timeZoneOffset)
          : newPlan.Name;
      const { backupPlanName } = this.getBackupNameAndPoint(newPlan);

      this.restoreDatabaseModel.planNameStep = RestoreStepsDataFromPlanHelper.updatePlanNameStep(name, newPlan.DeletePlan);
      this.restoreDatabaseModel.whereBackupStep = StepsDataFromPlanHelper.updateWhereBackup(
        newPlan.IsHybridBackup,
        newPlan.HybridID,
        newPlan.ConnectionID
      );
      this.restoreDatabaseModel.Storages = this.storages;
      this.restoreDatabaseModel.computerToRestoreStep.computerName = newPlan.RestoreSourcePrefix || '';
      this.restoreDatabaseModel.backupToRestoreStep = RestoreStepsDataFromPlanHelper.updateBackupToRestore(
        newPlan,
        this.planType,
        backupPlanName,
        settings.isUnix
      );
      this.restoreDatabaseModel.restorePointStep = RestoreStepsDataFromPlanHelper.updateRestorePointForDB(newPlan, settings.timeZoneOffset);

      if (settings.planType === PlanTypes.RestoreDataBasePlan) {
        this.restoreDatabaseModel.sqlServerInstanceStep = StepsDataFromPlanHelper.updateSQLServerInstance(newPlan, this.isCreate);
        this.restoreDatabaseModel.destinationStep = RestoreStepsDataFromPlanHelper.updateDBDestinationStep(newPlan, this.isUnix);
      } else this.restoreDatabaseModel.destinationStep = RestoreStepsDataFromPlanHelper.updateDBDestinationFileStep(newPlan);

      this.restoreDatabaseModel.restoreSourceStep = RestoreStepsDataFromPlanHelper.updateDBSource(newPlan, this.isUnix, this.isCreate);
      this.restoreDatabaseModel.encryptionOptionsStep = RestoreStepsDataFromPlanHelper.updateEncryptionOptionsStep(
        newPlan,
        settings.mode === PlanMode.create,
        this.isNBF
      );
      this.restoreDatabaseModel.scheduleStep = StepsDataFromPlanHelper.updateSchedule(
        newPlan,
        plan.OverdueAfterSuccess,
        this.isCreate,
        this.isUnix,
        true
      );
      this.restoreDatabaseModel.prePostActionsStep = StepsDataFromPlanHelper.updatePrePostActions(newPlan, true);
      this.restoreDatabaseModel.notificationStep = StepsDataFromPlanHelper.updateNotification(newPlan.Notification);
    }

    this.updateFormIfExistInitialData(settings, this.restoreDatabaseModel);

    return this.restoreDatabaseModel;
  }
}
